const KnightsLoading = () => {

    return (
        <div className='loading-container d-none' id='loading'>
            <div className="loader">
                <div className="square" ></div>
                <div className="square"></div>
                <div className="square last"></div>
                <div className="square clear"></div>
                <div className="square"></div>
                <div className="square last"></div>
                <div className="square clear"></div>
                <div className="square "></div>
                <div className="square last"></div>
            </div>
        </div>
    )
}

export default KnightsLoading;
